
import { defineComponent } from "vue";

export default defineComponent({
  name: "kt-tablet-and-mobile",
  components: {},
});
